(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["press-carousel"] && !Shopify.designMode) return;
  try {
    
  $(document).ready(function() {
    $('.press-carousel').slick({
      slidesToShow: 1,
      dots: true,
      useTransform: false,
      mobileFirst: true,
      responsive: [
        {
          breakpoint: 768,
          settings: 'unslick',
        },
      ],
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vincero-reviews-carousel"] && !Shopify.designMode) return;
  try {
    
  $('.carousel-review-cards').slick({
    slidesToShow: 1, // Show 1 slide by default
    centerMode: true,
    mobileFirst: true,
    dots: true,
    arrows: true,
    centerPadding: '12.5%', // 1/8 of a slide on each side
    nextArrow: '<div class="slick-next"><i class="fa fa-angle-right"></i></div>',
    prevArrow: '<div class="slick-prev"><i class="fa fa-angle-left"></i></div>',
    responsive: [
      {
        breakpoint: 800,
        settings: {
          slidesToShow: 4, // Show 5 slides above 800px
          centerMode: false,
          centerPadding: '0',
        },
      },
    ],
  });

  } catch(e) { console.error(e); }
})();
})();
